import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { formPaths } from '@shared/constants/form-paths.const';
import {
    requiredBy,
    ckTerreniHelper,
    schedaCoopAgricoleCkHelper,
    lavoroAgricoloRequired,
    prodottiAgricoliRequired,
    stabilimentoHelper,
    getSchedaCoopAgricoleControl,
} from './helpers/scheda-coop-agricole-form-validators.helper';

export const schedaCoopAgricoleRules: FormGroupRules = {
    my_CkFornisceServiziSoci: (form: FormGroup) => {
        requiredBy(form, 'my_CkFornisceServiziSoci', lavoroAgricoloRequired(form));
    },

    my_CkFornisceServiziNonSoci: (form: FormGroup) => {
        requiredBy(form, 'my_CkFornisceServiziNonSoci', lavoroAgricoloRequired(form));
    },

    my_ProdottiConferitiDaiSoci: (form: FormGroup) => {
        requiredBy(form, 'my_ProdottiConferitiDaiSoci', prodottiAgricoliRequired(form));
    },

    my_ProdottiAcquistatiDaTerzi: (form: FormGroup) => {
        requiredBy(form, 'my_ProdottiAcquistatiDaTerzi', prodottiAgricoliRequired(form));
    },

    my_LavorazioniSvolte: (form: FormGroup) => {
        requiredBy(form, 'my_LavorazioniSvolte', prodottiAgricoliRequired(form));
    },

    my_ckTerreniAQualsiasiTitolo: (form: FormGroup) => {
        requiredBy(form, 'my_ckTerreniAQualsiasiTitolo', lavoroAgricoloRequired(form));
    },

    my_CkDispStabilimento: (form: FormGroup) => {
        requiredBy(form, 'my_CkDispStabilimento', prodottiAgricoliRequired(form));
    },

    my_CkCicloBio: (form: FormGroup) => {
        requiredBy(form, 'my_CkCicloBio', prodottiAgricoliRequired(form));
    },

    my_CkFruisceProvvidenze: (form: FormGroup) => {
        ckTerreniHelper(form, 'my_CkFruisceProvvidenze', lavoroAgricoloRequired(form));
    },

    my_ColturePraticate: (form: FormGroup) => {
        ckTerreniHelper(form, 'my_ColturePraticate', lavoroAgricoloRequired(form));
    },

    my_TerreniProprieta: (form: FormGroup) => {
        ckTerreniHelper(form, 'my_TerreniProprieta', lavoroAgricoloRequired(form));
    },

    my_TerreniInFitto: (form: FormGroup) => {
        ckTerreniHelper(form, 'my_TerreniInFitto', lavoroAgricoloRequired(form));
    },

    my_TerreniAdAltroTitolo: (form: FormGroup) => {
        ckTerreniHelper(form, 'my_TerreniAdAltroTitolo', lavoroAgricoloRequired(form));
    },

    my_TerreniConduzioneUnica: (form: FormGroup) => {
        ckTerreniHelper(form, 'my_TerreniConduzioneUnica', lavoroAgricoloRequired(form));
    },

    my_TerreniConduzioneDivisa: (form: FormGroup) => {
        ckTerreniHelper(form, 'my_TerreniConduzioneDivisa', lavoroAgricoloRequired(form));
    },

    my_ProvvidenzePerCalamita: (form: FormGroup) => {
        const ckFruisceProvvidenze: string = getSchedaCoopAgricoleControl(form, 'my_CkFruisceProvvidenze').value;
        ckTerreniHelper(form, 'my_ProvvidenzePerCalamita', ckFruisceProvvidenze === '1' && lavoroAgricoloRequired(form));
    },

    my_ElencoServiziSoci: (form: FormGroup) => {
        schedaCoopAgricoleCkHelper(form, 'my_ElencoServiziSoci', 'my_ckSerSocAltro', 1, lavoroAgricoloRequired(form));
    },

    my_ElencoServiziNonSoci: (form: FormGroup) => {
        schedaCoopAgricoleCkHelper(form, 'my_ElencoServiziNonSoci', 'my_CkFornisceServiziNonSoci', 1, lavoroAgricoloRequired(form));
    },

    my_NoteCicloBio: (form: FormGroup) => {
        schedaCoopAgricoleCkHelper(form, 'my_NoteCicloBio', 'my_CkCicloBio', 1, prodottiAgricoliRequired(form));
    },

    my_StabilimentoAdAltroTitolo: (form: FormGroup) => {
        const ckStabilimentoAltroTit: string = getSchedaCoopAgricoleControl(form, 'my_CkStabilimentoAltroTit').value;
        schedaCoopAgricoleCkHelper(
            form,
            'my_StabilimentoAdAltroTitolo',
            'my_CkDispStabilimento',
            1,
            ckStabilimentoAltroTit === '1' && prodottiAgricoliRequired(form)
        );
    },

    my_CkStabilimentoPropr: (form: FormGroup) => {
        stabilimentoHelper(form);
    },
};
